<template>
  <v-card class="d-flex flex-column" flat tile color="rgb(0,160,233)">
    <div class="text-right mr-1 mt-1">
      <v-btn x-small icon @click="close()">
        <v-icon x-small>mdi-close</v-icon>
      </v-btn>
    </div>
    <h3 class="white--text text-center">
      {{ appTitle }}
    </h3>
    <img class="mb-3" :src="AssetsImage" height="45" width="100%" />
    <div class="text-center">
      <img :src="amamizu" height="90" />
    </div>

    <AlertContainer
      v-show="selectedTabId === 'alert'"
      class="overflow-y-auto"
      style="height: calc(100vh - 320px)"
    />

    <v-card
      class="mx-2 my-2 pa-1 white--text"
      height="90"
      width="320"
      tile
      dark
      color="rgba(0,0,0,0.2)"
    >
      <h5>お知らせ</h5>
      <div
        class="caption"
        style="overflow-y: scroll; height: 60px"
        v-html="sysMsg"
      ></div>
    </v-card>
  </v-card>
</template>

<script>
import axios from "axios";
import amamizu from "@/assets/images/png/amamizu.png";
import AssetsImage from "@/assets/LogoLarge.svg";
import AlertContainer from "./AlertContainer";
export default {
  name: "RightSideContents",
  components: {
    AlertContainer,
  },
  data() {
    return {
      sysMsg: null,
      AssetsImage,
      amamizu,
      tabs: [
        {
          id: "alert",
          label: "警報・注意報"
        },
        {
          id: "chat",
          label: "チャット"
        }
      ],
      selectedTabId: "alert"
    };
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE;
    }
  },
  created() {
    this.loadSystemMessage();
  },
  methods: {
    close() {
      this.$store.commit("SET_IS_RIGHT_NAV", false);
    },
    async loadSystemMessage() {
      this.sysMsg = null;
      const response = await axios
        .create({
          responseType: "json"
        })
        .get("https://amamizu.riskma.jp/sys_msg.json");
      if (response.data && response.data.html) {
        this.sysMsg = response.data.html;
      }
    }
  }
};
</script>